import { render, staticRenderFns } from "./reformInfo.vue?vue&type=template&id=19a80d04&scoped=true&"
import script from "./reformInfo.vue?vue&type=script&lang=js&"
export * from "./reformInfo.vue?vue&type=script&lang=js&"
import style0 from "./reformInfo.vue?vue&type=style&index=0&id=19a80d04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a80d04",
  null
  
)

export default component.exports